var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19064 13.1667C2.61268 13.1667 1.3335 11.9025 1.3335 10.3431C1.3335 8.78374 2.61268 7.51961 4.19064 7.51961C4.38005 7.51961 4.56516 7.53782 4.74427 7.57258M9.58746 5.85147C9.98464 5.71274 10.4121 5.63726 10.8573 5.63726C11.2938 5.63726 11.7131 5.70979 12.1036 5.84332M4.74427 7.57258C4.59154 7.1652 4.5081 6.72458 4.5081 6.26471C4.5081 4.18552 6.21368 2.5 8.31762 2.5C10.2774 2.5 11.8916 3.96247 12.1036 5.84332M4.74427 7.57258C5.12055 7.64559 5.47035 7.7916 5.77794 7.99507M12.1036 5.84332C13.5955 6.35349 14.6668 7.75408 14.6668 9.40196C14.6668 11.2066 13.3819 12.7147 11.6668 13.0815",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 11.1666V15.1666M7.99984 11.1666L9.33317 12.5M7.99984 11.1666L6.6665 12.5",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/CloudUpload.6a9e551f4174a03e361d66bed08c7255.svg";
export { ForwardRef as ReactComponent };